export default __webpack_public_path__ + "locales/pt/ChangePortalOwner.json?hash=6900a11fa80cc7a02dc31356d056dea7";